import { useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import AuthenticationTransition from '../components/AuthenticationTransition';

export interface LoginPageProps {
  onLogin: () => void | Promise<void>;
}

const LoginPage = ({ onLogin }: LoginPageProps) => {
  const started = useRef(false);

  useEffect(() => {
    if (started.current)
      return;

    started.current = true;
    void onLogin();
  }, [onLogin]);

  return <AuthenticationTransition message="Opening secure sign-in…" />;
};

export const AuthenticatedLoginRedirect = () => <Redirect to="/" />;

export default LoginPage;
